import { render, staticRenderFns } from "./BtnInserirMovimentacao.vue?vue&type=template&id=1a3f4c9d&"
import script from "./BtnInserirMovimentacao.vue?vue&type=script&lang=js&"
export * from "./BtnInserirMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports